export const ACCEPT_QUOTE = 'acceptQuote'
export const COMPLETE_WORK_ORDER = 'completeWorkOrder'
export const UNCOMPLETE_WORK_ORDER = 'uncompleteWorkOrder'
export const ACTIVE_LINK = 'activeLink'
export const ADD_CONTRACTOR = 'addContractor'
export const ADD_FORM_FIELD = 'addFormField'
export const ADD_PROPERTY_NOTE = 'addPropertyNote'
export const ADD_QUOTE_NOTE = 'addQuoteNote'
export const ADD_REPORT_PRICING = 'addReportPricing'
export const ASSIGN_QUOTE = 'assignQuote'
export const COMPONENT_METHOD = 'componentMethod'
export const CLEAR_MODALS = 'clearModals'
export const CLOSE_FORM = 'closeForm'
export const CLOSE_MODAL = 'closeModal'
export const CLOSE_MODAL_FORM = 'closeModalForm'
export const CLOSE_REPORT = 'closeReport'
export const CONVERT_TRADES_REPORT = 'convertTradesReport'
export const CURRENT_DATABASE_SEARCH = 'currentDatabaseSearch'
export const CURRENT_QUOTES_SEARCH = 'currentQuotesSearch'
export const CURRENT_REPORT_SEARCH = 'currentReportSearch'
export const DELETE_COMPANY = 'deleteCompany'
export const DELETE_COMPANY_MANAGER = 'deleteCompanyManager'
export const DELETE_DATABASE_OBJECT = 'deleteDatabaseObject'
export const DELETE_NOTE = 'deleteNote'
export const DELETE_PROPERTY = 'deleteProperty'
export const DELETE_EPMA = 'deleteEPMA'
export const DELETE_EPMA_CONTRACT = 'deleteEPMAContract'
export const DELETE_PROPERTY_PHOTO = 'deletePropertyPhoto'
export const DELETE_QUOTE = 'deleteQuote'
export const DELETE_REPORT = 'deleteReport'
export const DELETE_TAX_INVOICE_REQUEST = 'deleteTaxInvoiceRequest'
export const DELETE_QUOTE_NOTE = 'deleteQuoteNote'
export const DISPLAY_SIDEBAR = 'displaySidebar'
export const DUPLICATE_ASBESTOS_REPORT = 'duplicateAsbestosReport'
export const DUPLICATE_DEFECTS_REPORT = 'duplicateDefectsReport'
export const DUPLICATE_ESM_REPORT = 'duplicateEsmReport'
export const DUPLICATE_INCIDENT_REPORT = 'duplicateIncidentReport'
export const DUPLICATE_INSPECTION_REPORT = 'duplicateInspectionReport'
export const DUPLICATE_INSURANCE_REPORT = 'duplicateInsuranceReport'
export const DUPLICATE_OHS_REPORT = 'duplicateOhsReport'
export const DUPLICATE_PROPERTY_PHOTOS_REPORT = 'duplicatePropertyPhotosReport'
export const DUPLICATE_QUOTE = 'duplicateQuote'
// export const START_INSPECTION = 'startInspection'
// export const END_INSPECTION = 'endInspection'
export const EDIT_INSPECTION_TIMES = 'editInspectionTimes'
export const VIEW_INSPECTION_TIMES = 'viewInspectionTimes'
export const SCHEDULE_QUOTE_ACCESS = 'scheduleQuoteAccess'
export const VIEW_QUOTE_ACCESS = 'viewQuoteAccess'
export const DUPLICATE_TAX_INVOICE_REQUEST = 'duplicateTaxInvoiceRequest'
export const EDIT_COMPANY = 'editCompany'
export const EDIT_COMPANY_MANAGER = 'editCompanyManager'
export const EDIT_DATABASE_OBJECT = 'editDatabaseObject'
export const EDIT_MASTER_NOTE = 'editMasterNote'
export const EDIT_NOTE = 'editNote'
export const EDIT_PROPERTY = 'editProperty'
export const EDIT_REPORT_PRICING = 'editReportPricing'
export const EDIT_QUOTE_NOTE = 'editQuoteNote'
export const EDIT_EPMA = 'editEPMA'
export const MAIL_EPMA = 'sendEPMAEmail'
export const INVOICE_EPMA = 'invoiceEPMA'
export const EXPIRED_SESSION = 'expiredSession'
export const GENERATE_ASBESTOS_PDF = 'generateAsbestorPdf'
export const GENERATE_DEFECTS_PDF = 'generateDefectsPdf'
export const GENERATE_ESM_PDF = 'generateEsmPdf'
export const GENERATE_INCIDENT_PDF = 'generateIncidentPdf'
export const GENERATE_INSPECTION_PDF = 'generateInspectionPdf'
export const GENERATE_INSURANCE_PDF = 'generateInsurancePdf'
export const GENERATE_OHS_PDF = 'generateOhsPdf'
export const GENERATE_PROPERTY_PHOTOS_PDF = 'generatePropertyPhotosPdf'
export const GENERATE_TRADES_PDF = 'generateTradesPdf'
export const GET_FORM_FIELD = 'getFormField'
export const GET_FORM_VALUE = 'getFormValue'
export const GET_IN_USE_REPORTS = 'getInUseReports'
export const IN_USE_REPORTS = 'inUseReports'
export const INVOICE_STATUS_OCMANAGER = 'invoiceStatusOCManager'
export const LIVE_FEED = 'liveFeed'
export const OCMANAGERS_FEED = 'ocMangersFeed'
export const LOAD_ACCOUNT = 'loadAccount'
export const LOAD_COMPANY = 'loadCompany'
export const LOAD_COMPANY_CONTRACTORS = 'loadCompanyContractors'
export const LOAD_COMPANY_MANAGERS = 'loadCompanyManagers'
export const LOAD_COMPANY_PROPERTIES = 'loadCompanyProperties'
export const LOAD_DATA = 'loadData'
export const LOAD_DASHBOARD = 'loadDashboard'
export const LOAD_DIRECTORY = 'loadDirectory'
export const LOAD_FORM = 'loadForm'
export const LOAD_PROPERTY = 'loadProperty'
export const LOAD_PROPERTY_CONTRACTORS = 'loadPropertyContractors'
export const LOAD_PROPERTY_NOTES = 'loadPropertyNotes'
export const LOAD_PROPERTY_PHOTOS = 'loadPropertyPhotos'
export const LOAD_EPMA = 'loadEPMA'
export const LOAD_QUOTES = 'loadQuotes'
export const LOAD_QUOTE_NOTES = 'loadQuoteNotes'
export const LOAD_REPORT_INFO = 'loadReportInfo'
export const LOAD_REPORTS = 'loadReports'
export const LOAD_SETTINGS = 'loadSettings'
export const LOAD_SIDEBAR = 'loadSidebar'
export const LOAD_STATS = 'loadStats'
export const LOAD_WIZARD_FORM = 'loadWizardForm'
export const LOGIN = 'login'
export const LOGIN_AS_USER = 'loginAsUser'
export const LOGOUT = 'logout'
export const MODIFY_FORM_FIELD = 'modifyFormField'
export const MODIFY_FORM_VALUE = 'modifyFormValue'
export const NEW_COMPANY_MANAGER = 'newCompanyManager'
export const NEW_CONTRACTOR = 'newContractor'
export const NEW_DATABASE_OBJECT = 'newDatabaseObject'
export const NEW_PROPERTY = 'newProperty'
export const NEW_PROPERTY_EXCEL = 'newPropertyExcel'
export const NEW_PROPERTY_CONTRACTOR = 'newPropertyContractor'
export const OPEN_CONFIRMATION_MODAL = 'openConfirmationModal'
export const OPEN_ERROR_MODAL = 'openErrorModal'
export const OPEN_MODAL = 'openModal'
export const REMOVE_FORM_FIELD = 'removeFormField'
export const SELECT_CONTRACTORS = 'selectContractors'
export const SEND_ASBESTOS_REPORT = 'sendAsbestosReport'
export const SEND_DEFECTS_REPORT = 'sendDefectsReport'
export const SEND_ESM_REPORT = 'sendEsmReport'
export const SEND_INCIDENT_REPORT = 'sendIncidentReport'
export const SEND_INSPECTION_REPORT = 'sendInspectionReport'
export const SEND_INSURANCE_REPORT = 'sendInsuranceReport'
export const SEND_OHS_REPORT = 'sendOhsReport'
export const SEND_PROPERTY_PHOTOS_REPORT = 'sendPropertyPhotosReport'
export const SEND_QUOTE = 'sendQuote'
export const SEND_TAX_INVOICE_REQUEST = 'sendTaxInvoiceRequest'
export const COMPLETE_TAX_INVOICE_REQUEST = 'completeTaxInvoiceRequest'
export const SEND_TRADES_REPORT = 'sendTradesReport'
export const SET_PROPERTY_ACTIONS = 'setPropertyActions'
export const SET_EPMA_ACTIONS = 'setEPMAActions'
export const SUBMIT_FORM = 'submitForm'
export const TOGGLE_SIDEBAR = 'toggleSidebar'
export const UPLOAD_APP_ICON = 'uploadAppIcon'
export const UPLOAD_DEFECTS_PDF = 'uploadDefectsPdf'
export const UPLOAD_INCIDENT_PDF = 'uploadIncidentPdf'
export const UPLOAD_INSPECTION_PDF = 'uploadInspectionPdf'
export const UPLOAD_INVOICE = 'uploadInvoice'
export const UPLOAD_OHS_PDF = 'uploadOhsPdf'
export const UPLOAD_PROPERTY_PHOTO = 'uploadPropertyPhoto'
export const UPLOAD_REPORT_ICON = 'uploadReportIcon'
export const UPLOAD_TRADES_REPORT = 'uploadTradesReport'
export const UPLOAD_EPMA_CONTRACT = 'uploadEPMAContract'
export const ADD_TICKET_PRIORITY = 'addTicketPriority'
export const CLOSE_TICKET = 'closeTicket'
export const DELETE_TICKET = 'deleteTicket'
export const LOAD_TICKET = 'loadTicket'
export const REOPEN_TICKET = 'reopenTicket'
export const REMOVE_TICKET_PRIORITY = 'removeTicketPriority'
export const LOAD_CARDS = 'loadCards'
export const GET_QUOTE_TRELLO_ATTACHMENTS = 'getQuoteTrelloAttachments'
export const GET_QUOTE_ATTACHMENTS = 'getQuoteAttachments'
export const TERMINATE_QUOTE = 'terminateQuote'
export const FEEDBACK = 'feedback'
export const UNACCEPT_QUOTE = 'unacceptQuote'
export const GENERATE_ACCEPTANCE_RATE_REPORT = 'generateManagerAcceptanceRateReport'
export const EDIT_ACCEPTANCE_RATE_REPORT = 'editManagerAcceptanceRateReport'
export const GENERATE_COMPANY_ACCEPTANCE_RATE_REPORT = 'generateCompanyAcceptanceRateReport'
export const EDIT_COMPANY_ACCEPTANCE_RATE_REPORT = 'editCompanyAcceptanceRateReport'
export const GENERATE_ACTIVITY_STATEMENT = 'generateStaffActivityStatement'
export const EDIT_ACTIVITY_STATEMENT = 'editStaffActivityStatement'
export const VIEW_COMPANY_PORTFOLIO = 'viewCompanyPortfolio'
export const REQUEST_QUOTE_SIGNATURE = 'requestQuoteSignature'
export const REQUEST_EPMA_SIGNATURE = 'requestEPMASignature'
export const LOAD_ACTIVE_DATES = 'loadActiveDates'
export const GENERATE_ALL_COMPANY_STATS = 'generateAllCompanyStats'
export const GENERATE_COMPANY_PORTFOLIO = 'generateCompanyPortfolio'
export const VIEW_ALL_COMPANY_STATS = 'viewAllCompanyStats'




// WEBPACK FOOTER //
// ./src/vuex/types.js